import React from 'react'
import styled from "styled-components";
import CopyrightIcon from "@mui/icons-material/Copyright";

function Footer() {
  return (
    <FooterWraper>
     Created By Vikram | <span><CopyrightIcon className='icon'/></span> 2022 
    </FooterWraper>
  );
}

export default Footer

const FooterWraper = styled.div`
  background-color: #404040;
  width: 100%;
  height: 40px;
  text-align: center;
  padding-top: 20px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.2);
  position: relative;
  color: ${(props) => props.theme.text.main};

  & span {
    margin-top: 20px;
    padding-right: 30px;
  }

  .icon {
    position: absolute;
  }

  @media (max-width: 460px) {
    width: 100%;
    padding-left: 10px;
    padding-right: 10px;
  }
`;
